
import React from 'react';

import { FaStarOfLife } from "react-icons/fa";
import { Form, Button } from 'react-bootstrap';
import './SettingsMobile.css'

import '../../Variable.css';

import ProfileLogic from './ProfileLogic';
function ProfileMobile() {

    const { isLoading, handleNameChange, handleSubmit, hud, username, email, name } = ProfileLogic();

    return (
        <div className="card1-mb mx-auto ">
            <div className="card1-header-mb text-right  rounded" >
                <h1 >Edit Profile</h1>
                <span>Set Up Your Personal Information</span>
            </div>
            <hr></hr>
            <div className="card1-body">
                <div className="row justify-content-center">
                    <div className="col-xl-12 col-lg-16 col-xs-24">
                        {isLoading ? (
                            <div style={{ textAlign: 'center', color: 'black', height: '600px', paddingTop: '300px', }}>
                                <>{hud('Please Wait...')}</>
                            </div>
                        ) : (
                            <Form onSubmit={handleSubmit} className="mx-auto d-block w-100 px-3">
                                <Form.Group controlId="formName" className="mx-auto w-100 text-left">
                                    <Form.Label className="d-block bold-label-mb">
                                        <FaStarOfLife className="text-danger" style={{ width: '8px' }} /> Name :
                                    </Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="name"
                                        defaultValue={username}
                                        value={name}
                                        onChange={handleNameChange}
                                        maxLength={50}
                                        required
                                        className="text-black mb-3 input-form-mb"
                                    />
                                </Form.Group>
                                <Form.Group controlId="formEmail" className="mx-auto w-100 text-left">
                                    <Form.Label className='bold-label-mb'>Email Id :</Form.Label>
                                    <br />
                                    <Form.Text className="text-muted">
                                        {email}
                                    </Form.Text>
                                    <br />
                                    <Button type="submit" className="btn1-mb border-0 btn-2-mb">
                                        Update Profile
                                    </Button>
                                </Form.Group>
                            </Form>
                        )}
                    </div>
                </div>
            </div>
        </div>

    )
}

export default ProfileMobile;